import angular from 'angular';
import template from './mobile-doctor-actions.html';
class GroupCallMobileDoctorActionsController {
    $onInit() {
        if (this.stream.type === 'screen') {
            this.name = this.username + "'s screen";
        }
        else {
            this.name = this.username;
        }
    }
}
const groupCallMobileDoctorActions = {
    template,
    bindings: {
        stream: '<',
        isInGroupCall: '<',
        username: '<',
        disabled: '<',
        onToggleAudio: '&',
        onCallEnd: '&',
        onTogglePin: '&',
        isPinned: '<',
    },
    controller: GroupCallMobileDoctorActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.participantVideoFrame.participantVideoFrameFull.actions.groupCall.mobileDoctorActions', [])
    // participant-group-call-mobile-doctor-actions
    .component('participantGroupCallMobileDoctorActions', groupCallMobileDoctorActions).name;
